// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__2-ohA","delayed":"styles_delayed__1gAbQ","other-brand":"styles_other-brand__2WMjF","otherBrand":"styles_other-brand__2WMjF"};